<div *ngIf="!!piece && !!settings; then withData"></div>

<ng-template #withData>
  <ng-container *ngComponentOutlet="piece | dynamicIdtComponentResolution: 'render';
    ndcDynamicInputs:{
    piece: piece,
    settings: settings,
    country: country,
    lang: lang,
    type: 'render',
    slot: slot
  };"></ng-container>
</ng-template>
